// This component returns one single tile within the tabRibbon.
// Each tile has actions to rename the tile & delete the tile

import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import TableChartIcon from '@mui/icons-material/TableChart';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import Filter9PlusOutlinedIcon from '@mui/icons-material/Filter9PlusOutlined';
import { useState, useRef } from 'react';
import { Dispatch } from 'redux';
import { duplicateControl } from '../../redux/ChartPoperties/ChartControlsActions';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
  ChartControl,
  ChartControlsProps,
  ChartControlStateProps,
} from '../../redux/ChartPoperties/ChartControlsInterface';
import { duplicateChartProperty } from '../../redux/ChartPoperties/ChartPropertiesActions';
import {
  ChartPropertiesProps,
  ChartPropertiesStateProps,
} from '../../redux/ChartPoperties/ChartPropertiesInterfaces';
import {
  updateSelectedTile,
  actionsToAddTile,
} from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { updateSelectedTileToTab } from '../../redux/TabTile/TabActions';
import { TabStateProps, TabStateProps2 } from '../../redux/TabTile/TabStateInterfaces';
import { TabTileStateProps, TabTileStateProps2 } from '../../redux/TabTile/TabTilePropsInterfaces';
import { TileStateProps, TileStateProps2 } from '../../redux/TabTile/TileStateInterfaces';
import './individualTile.css';
import { connect } from 'react-redux';
import { renameTile } from '../../redux/TabTile/TileActions';
import {
  duplicateChartFilterGroups,
  addChartFilterTabTileName,
} from '../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { ChartFilterGroupProps } from '../../redux/ChartFilterGroup/ChartFilterGroupInterface';
import { ChartFilterGroupStateProps } from '../../redux/ChartFilterGroup/ChartFilterGroupInterface';
import Logger from '../../Logger';
import ClearIcon from '@mui/icons-material/Clear';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Dialog, Tooltip, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { fontSize, palette } from '../../index';
import { select } from 'slate';
import { NotificationDialog } from '../CommonFunctions/DialogComponents';
import { AlertColor } from '@mui/material';
import { RootState } from '../../redux';
import { MoreVert } from '@mui/icons-material';
import { LuMoveHorizontal } from 'react-icons/lu';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import { DeleteConfirmationDialog } from './DeleteConfirmationDialog';

type IndTileStateProps = TabStateProps2 &
  TileStateProps2 &
  TabTileStateProps2 &
  ChartPropertiesStateProps &
  ChartFilterGroupStateProps &
  ChartControlStateProps;

interface IndividualTileProps {
  //state
  tabTileProps: TabTileStateProps;
  tabState: TabStateProps;
  tileState: TileStateProps;
  chartProperties: ChartPropertiesProps;
  chartControls: ChartControl;
  chartGroup: ChartFilterGroupProps;
  //props from parent
  totalTile: number;
  tileIndex: number;
  tabName: string;
  tileName: string;
  editing: boolean;
  selectedTile: number;
  tabId: number;
  tileId: number;
  showDash: boolean;
  popupClass?: string;
  inPopup?: boolean;
  MaxTiles: number;
  editingTileId: number | null;

  tabAreaBackgroundColor?: string;
  selectedTabBackgroundColor?: string;
  iconColor?: string;

  style?: React.CSSProperties;
  //functions
  renameTileBegin: (tabId: number, tileId: number) => void;
  renameTileComplete: (renameValue: string, tabId: number, tileId: number) => void;
  selectTile: (tileId: number, tileName: string, tabId: number, tabName: string) => void;
  removeTile: (tabId: number, tileId: number) => void;
  reOrderTileList: () => void;
  //dispatch
  renameTile: (tabId: number, nextTileId: number, newName: string) => void;
  actionsToAddTile: (
    tabId: number,
    nextTileId: number,
    table: any,
    fromTab: boolean,
    selectedDs: any,
    selectedTablesInDs: any,
    chartControl: ChartControlsProps,
  ) => void;
  duplicateControl: (propKey: string, chartControl: ChartControlsProps) => void;
  duplicateChartProperty: (propKey: string, chartProp: any) => void;
  addChartFilterTabTileName: (selectedDatasetID: string, tabTileName: string) => void;
  duplicateChartFilterGroups: (tabTileName: string, selectedGroups: any) => void;
  updateSelectedTile: (tileName: string, tileId: number, nextTileId: number) => void;
  updateSelectedTileToTab: (tabId: number, tileName: string, tileId: number) => void;
  otherTileNames?: string[];
}

const IndividualTile = ({
  // props from Parent
  tileIndex,
  totalTile,
  tabName,
  tileName,
  editing,
  selectedTile,
  tabId,
  tileId,
  showDash,
  MaxTiles,
  tabAreaBackgroundColor,
  selectedTabBackgroundColor,
  iconColor,
  editingTileId,
  // functions in parent
  renameTileBegin,
  renameTileComplete,
  selectTile,
  removeTile,
  reOrderTileList,
  //Dispatch
  renameTile,
  actionsToAddTile,
  duplicateControl,
  duplicateChartProperty,
  duplicateChartFilterGroups,
  addChartFilterTabTileName,
  updateSelectedTile,
  updateSelectedTileToTab,

  //state
  tabTileProps,
  tabState,
  tileState,
  chartControls,
  chartProperties,
  chartGroup,
  dashBoardFilterGroup,
  popupClass,
  inPopup = false,
  tileListOpen,
  otherTileNames = [],
}: IndividualTileProps & any) => {
  const [renameValue, setRenameValue] = useState<string>(tileName);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

  const [notification, setNotification] = useState({
    open: false,
    severity: 'warning' as AlertColor,
    message: '',
  });

   const propKey = `${tabId}.${tileId}`;

   const chartTitle =
     chartProperties?.properties?.[propKey]?.titleOptions?.chartTitle ||
     chartProperties?.properties?.[propKey]?.chartTitle ||
     '';

  const showNotification = (message: string, severity: AlertColor = 'warning') => {
    setNotification({
      open: true,
      severity,
      message,
    });
  };

  const selectAndRename = () => {
    renameTileBegin(tabId, tileId);
  };

  const handleCloseNotification = () => {
    setNotification((prev) => ({ ...prev, open: false }));
  };

  const cancelDelete = (e: any) => {
    e.stopPropagation();
    setShowDeleteConfirmation(false);
  };

  const confirmAndDelete = (e: any) => {
    e.stopPropagation();
    removeTile(tabId, tileId);
    setShowDeleteConfirmation(false);
  };

  const handleDeleteTile = () => {
    setShowDeleteConfirmation(true);
  };

  const handleTileNameValue = (e: any) => {
    setRenameValue(e.target.value);
  };

  var menuStyle = { fontSize: '12px', padding: '2px 1rem' };

  const [anchorEl, setAnchorEl] = useState<null | any>(null);
  const open: boolean = Boolean(anchorEl);

  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState<null | any>(null);
  const openSubMenu: boolean = Boolean(subMenuAnchorEl);
  const [activeItem, setActiveItem] = useState<string | null>(null);

  const handleSubmenuClose = () => {
    setSubMenuAnchorEl(null);
    setActiveItem(null);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [anchorEl1, setAnchorEl1] = useState(null);
  const open1 = Boolean(anchorEl1);

  const handleClickAnchor = (event: any) => {
    event.stopPropagation();
    setAnchorEl1(event.currentTarget);
  };

  const handleCloseAnchor = () => {
    setAnchorEl1(null);
  };

  function setDuplicateName(
    fromTileName: string,
    newName: string,
    count: number,
    tabId: number,
    nextTileId: number,
    duplicatedAs: string,
    sourcePropKey: string,
  ) {
    tileState.tileList[tabId].forEach((tileKey: any) => {
      if (tileState.tiles[tileKey].tileName === newName) {
        count = count + 1;
        newName = `${fromTileName} - ${duplicatedAs}(${count})`;
        setDuplicateName(
          fromTileName,
          newName,
          count,
          tabId,
          nextTileId,
          duplicatedAs,
          sourcePropKey,
        );
      }
    });
    renameTile(tabId, nextTileId, newName);

    let selectedFilterGroups = chartGroup.tabTile[sourcePropKey] || [];
    let selectedDatasetID = chartProperties.properties[sourcePropKey].selectedDs.id;

    ///	if (!(selectedFilterGroups && selectedFilterGroups.length > 0)) {
    addChartFilterTabTileName(selectedDatasetID, `${tabId}.${nextTileId}`);
    duplicateChartFilterGroups(`${tabId}.${nextTileId}`, selectedFilterGroups);
    ///	}
  }
  // const handleDuplicateAsCrossTab = () => {
  //   handleClose1();

  //   const tabObj = tabState.tabs[tabTileProps.selectedTabId];
  //   const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  //   const nextPropKey = `${tabTileProps.selectedTabId}.${tabObj.nextTileId}`;
  //   const chartAxesLength = chartProperties.properties[propKey].chartAxes.length;
  //   console.log(chartAxesLength);

  //   // Clone existing properties
  //   const clonedControls = JSON.parse(JSON.stringify(chartControls.properties[propKey])) || {};
  //   const clonedProperties = JSON.parse(JSON.stringify(chartProperties.properties[propKey]))||{};

  //   // Override chart type to cross tab

  //   clonedControls.chartControls = {
  //     ...(clonedControls.chartControls || {}),
  //   };

  //   const crossTabProperties = {
  //     ...clonedProperties,
  //     chartType: "crossTab",
  //     crossTabStyleOptions: {
  //       ...(clonedProperties.crossTabStyleOptions || {}),
  //       borderWidth: 1,
  //       lineHeight: 1.25
  //     }
  //   };

  //   // Add the new cross tab tile
  //   actionsToAddTile(
  //     tabObj.tabId,
  //     tabObj.nextTileId,
  //     tabTileProps.selectedTable,
  //     false,
  //     crossTabProperties.selectedDs,
  //     crossTabProperties.selectedTable,
  //     clonedControls // Modified controls
  //   );

  //   // Update both control and property stores
  //   duplicateControl(nextPropKey, clonedControls);
  //   duplicateChartProperty(nextPropKey, crossTabProperties);

  //   // Handle naming
  //   const count = 0;
  //   const fromTileName = tileState.tiles[propKey].tileName;
  //   const newName = `${fromTileName} - Cross Tab`;

  //   setDuplicateName(
  //     fromTileName,
  //     newName,
  //     count,
  //     tabObj.tabId,
  //     tabObj.nextTileId
  //   );
  // };

  const handleDuplicateAsCrossTab = () => {
    handleCloseAnchor();
    if (tileState.tileList[tabId].length >= MaxTiles) {
      showNotification(`Maximum tile limit reached (${MaxTiles} tiles per tab)`);
      handleCloseAnchor();
      return;
    }

    const tabObj = tabState.tabs[tabId];
    const propKey = `${tabId}.${tileId}`;
    const nextPropKey = `${tabId}.${tabObj.nextTileId}`;
    const chartAxes = chartProperties.properties[propKey].chartAxes;
    const chartAxesLength = chartAxes.length;

    // Clone existing properties
    const clonedControls = JSON.parse(JSON.stringify(chartControls.properties[propKey])) || {};
    const clonedProperties = JSON.parse(JSON.stringify(chartProperties.properties[propKey])) || {};

    // Adjust chartAxes for crossTab based on length
    let crossTabAxes = [];
    if (chartAxesLength >= 2) {
      crossTabAxes = [
        {
          name: 'Filter',
          fields: chartAxes.find((axis: { name: string }) => axis.name === 'Filter')?.fields || [],
        },
        {
          name: 'Row',
          fields:
            chartAxes.find(
              (axis: { name: string }) =>
                axis.name === 'Dimension' ||
                axis.name === 'Date' ||
                axis.name === 'Row' ||
                axis.name === 'Location',
            )?.fields || [],
        },
        {
          name: 'Column',
          fields:
            chartAxes.find(
              (axis: { name: string }) => axis.name === 'Column' || axis.name === 'Split By',
            )?.fields || [],
        },
        {
          name: 'Measure',
          fields:
            chartProperties?.properties[propKey]?.chartType === 'scatterPlot'
              ? [
                  ...(chartAxes.find((axis: { name: string }) => axis.name === 'X Axis')?.fields ||
                    []),
                  ...(chartAxes.find((axis: { name: string }) => axis.name === 'Y Axis')?.fields ||
                    []),
                ]
              : chartAxes.find((axis: { name: string }) => axis.name === 'Measure')?.fields || [],
        },
      ];
    } else {
      console.error('Unsupported chartAxes length:', chartAxesLength);
      return;
    }

    const crossTabProperties = {
      ...clonedProperties,
      chartType: 'crossTab',
      chartAxes: crossTabAxes,
      crossTabStyleOptions: {
        ...(clonedProperties.crossTabStyleOptions || {}),
        borderWidth: 1,
        lineHeight: 18,
        lineWidth: 80,
      },
    };

    // Add the new cross tab tile
    actionsToAddTile(
      tabObj.tabId,
      tabObj.nextTileId,
      tabTileProps.selectedTable,
      false,
      crossTabProperties.selectedDs,
      crossTabProperties.selectedTable,
      clonedControls,
    );

    // Update both control and property stores
    duplicateControl(nextPropKey, clonedControls);
    duplicateChartProperty(nextPropKey, crossTabProperties);

    // Handle naming
    const count = 0;
    const fromTileName = tileState.tiles[propKey].tileName;
    const newName = `${fromTileName} - Cross Tab`;
    setDuplicateName(
      fromTileName,
      newName,
      count,
      tabObj.tabId,
      tabObj.nextTileId,
      'Cross Tab',
      propKey,
    );
  };

  const handleDuplicateTile = () => {
    handleCloseAnchor();
    if (tileState.tileList[tabId].length >= MaxTiles) {
      showNotification(`Maximum tile limit reached (${MaxTiles} tiles per tab)`);
      handleCloseAnchor();
      return;
    }

    // get all information about this tile and set in appropriate tile id
    // give a unique tile name

    let tabObj: any = tabState.tabs[tabId];

    var propKey: string = `${tabId}.${tileId}`;
    var nextPropKey: string = `${tabId}.${tabObj.nextTileId}`;

    actionsToAddTile(
      tabObj.tabId, //tabId
      tabObj.nextTileId, //nextTileId:
      tabTileProps.selectedTable, //table:
      false, //fromTab:
      chartProperties.properties[propKey]?.selectedDs, //selectedDs:
      chartProperties.properties[propKey]?.selectedTable, //selectedTablesInDs:
      JSON.parse(JSON.stringify(chartControls.properties[propKey])),
    );

    duplicateControl(nextPropKey, JSON.parse(JSON.stringify(chartControls.properties[propKey])));
    //

    duplicateChartProperty(nextPropKey, {
      ...JSON.parse(JSON.stringify(chartProperties.properties[propKey])),
      isDuplicate: true,
    });

    var count = 0;
    var fromTileName = tileState.tiles[propKey].tileName;
    var newName = `${fromTileName} - copy`;
    setDuplicateName(
      fromTileName,
      newName,
      count,
      tabObj.tabId,
      tabObj.nextTileId,
      'copy',
      propKey,
    );
  };

   const handleRenameAsChartTitle = () => {
    if (!chartTitle || chartTitle.trim() === '') return;

    const newName = chartTitle.trim();
    const isChartTitleDuplicate = otherTileNames.some(
      (name: string) => name.toLowerCase() === newName.toLowerCase()
    );

    if (isChartTitleDuplicate) {
      showNotification('Tile name already exists. Please make the chart title unique.');
      return;
    }

    setRenameValue(newName);
    renameTileComplete(newName, tabId, tileId);
  };

  // dialog message for delete tile
  const deleteMessage = tabState.tabs[tabId]?.tilesInDashboard?.includes(`${tabId}.${tileId}`) ? (
    <>
      Tile: <strong>{tileName}</strong> is used in the dashboard. <br />
      Are you sure want to delete?
    </>
  ) : (
    <>
      Do you want to Delete this Tile: <strong>{tileName}</strong>?
    </>
  );

  const RightClickMenu = () => {
    return (
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={open}
        onClose={() => handleClose()}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            renameTileBegin(tabId, tileId);
            handleClose();
          }}
          sx={menuStyle}
        >
          Rename Tile
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            handleDuplicateTile();
            handleClose();
          }}
          sx={menuStyle}
        >
          Duplicate Tile
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            removeTile(tabId, tileId);
            handleClose();
          }}
          sx={menuStyle}
        >
          Delete Tile
        </MenuItem>
      </Menu>
    );
  };

  const isTooLong = renameValue.length > 40;
  const isDuplicate = otherTileNames.some(
    (name: string) => name.toLowerCase() === renameValue.trim().toLowerCase()
  );

  const handleTileRename = (e: any) => {
    if (renameValue.trim() === '') {
      setRenameValue(tileName);
      renameTileComplete(tileName, tabId, tileId);
      return;
    }

    if (isDuplicate) {
      setRenameValue(tileName);
      renameTileComplete(tileName, tabId, tileId);
      return;
    }

    if (isTooLong) {
      setRenameValue(tileName);
      renameTileComplete(tileName, tabId, tileId);
      return;
    }

    if (renameValue.trim().length < 3) {
      setRenameValue(tileName);
      renameTileComplete(tileName, tabId, tileId);
      return;
    }

    renameTileComplete(renameValue.trim(), tabId, tileId);
  };

  const isEditingThisTile = editingTileId === tileId;

  // create menu options for tile move sub menu
  interface SubMenuOption {
    label: string;
    icon: JSX.Element;
    action: 'left' | 'right' | 'first' | 'last';
  }

  const getSubMenuOptions = (index: number, total: number): JSX.Element[] => {
    let options: SubMenuOption[] = [];

    if (index === 0) {
      options = [
        {
          label: 'To Right',
          icon: <ArrowForwardIcon style={{ width: 18, height: 18, color: iconColor }} />,
          action: 'right',
        },
        {
          label: 'To Last',
          icon: <LastPageIcon style={{ width: 18, height: 18, color: iconColor }} />,
          action: 'last',
        },
      ];
    } else if (index === total - 1) {
      options = [
        {
          label: 'To Left',
          icon: <ArrowBackIcon style={{ width: 18, height: 18, color: iconColor }} />,
          action: 'left',
        },
        {
          label: 'To First',
          icon: <FirstPageIcon style={{ width: 18, height: 18, color: iconColor }} />,
          action: 'first',
        },
      ];
    } else {
      options = [
        {
          label: 'To Left',
          icon: <ArrowBackIcon style={{ width: 18, height: 18, color: iconColor }} />,
          action: 'left',
        },
        {
          label: 'To Right',
          icon: <ArrowForwardIcon style={{ width: 18, height: 18, color: iconColor }} />,
          action: 'right',
        },
        {
          label: 'To First',
          icon: <FirstPageIcon style={{ width: 18, height: 18, color: iconColor }} />,
          action: 'first',
        },
        {
          label: 'To Last',
          icon: <LastPageIcon style={{ width: 18, height: 18, color: iconColor }} />,
          action: 'last',
        },
      ];
    }

    return options.map((option, ind) => (
      <MenuItem
        key={ind}
        onClick={() => {
          reOrderTileList(tabId, option.action, tileIndex);
          handleCloseAnchor();
          handleSubmenuClose();
        }}
      >
        <ListItemIcon>{option.icon}</ListItemIcon>
        <ListItemText primary={option.label} primaryTypographyProps={{ color: iconColor }} />
      </MenuItem>
    ));
  };

  if (isEditingThisTile) {
    return (
      <form
        style={{ display: 'inline' }}
        onSubmit={(evt: any) => {
          evt.preventDefault();
          if (!isTooLong) {
            evt.currentTarget.querySelector('input').blur();
          }
        }}
      >
        <Tooltip
          title={
            isDuplicate
              ? 'Tile name already exists'
              : isTooLong
              ? 'Tile name cannot exceed 40 characters'
              : renameValue.length === 40
                ? 'You have reached max limit of tile name'
                : renameValue.trim().length < 3
                  ? 'Tile name must be at least 3 characters long'
                  : renameValue === ''
                    ? 'Tile name cannot be empty'
                    : ''
          }
          placement="right"
          disableHoverListener={!isDuplicate && !isTooLong && renameValue.trim().length >= 3}
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          <input
            autoFocus
            value={renameValue}
            onChange={handleTileNameValue}
            className="editTileSelected"
            onBlur={handleTileRename}
            title="Press enter or click away to save"
            style={{
              borderBottom: `2px solid ${isTooLong ? 'red' : '#2bb9bb'}`,
            }}
            maxLength={40}
          />
        </Tooltip>
      </form>
    );
  } else {
    return (
      <span
        style={{
          height: '1.7rem',
          display: 'flex',
          alignItems: 'center',
          paddingTop: 0,
          overflow: 'hidden',
          justifyContent: 'space-between',
          backgroundColor:
            selectedTile === tileId && !showDash
              ? selectedTabBackgroundColor
              : tabAreaBackgroundColor,
          ...(popupClass ? { paddingLeft: '7px', width: '100%' } : {}),
        }}
        className={`${
          selectedTile === tileId && !showDash
            ? 'commonTile indiItemHighlightTile'
            : 'commonTile indiItemTile'
        } ${popupClass}`}
        onDoubleClick={(e) => {
          e.stopPropagation();
          if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
          }
          Logger('info', 'Double clicked');
          selectAndRename();
        }}
        onClick={(e) => {
          e.stopPropagation();

          if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
            Logger('info', 'Double clicked (via onClick)');
            selectAndRename();
          } else {
            timerRef.current = setTimeout(() => {
              Logger('info', 'Left clicked (single)');
              if (!anchorEl1) selectTile(tileId, tileName, tabId, tabName);
              timerRef.current = null;
            }, 250); // 250ms delay
          }
        }}
        title={`${tileName}.\nDouble click to edit name`}
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
          Logger('info', 'Right Click');
          setTimeout(() => {
            handleClick(e);
          }, 100);
        }}
      >
        <span className="tabText" style={{ marginTop: '1px', color: iconColor }}>
          {tileName.length > 35 ? tileName.substring(0, 35) + '...' : tileName}
        </span>
        {/* <ClearIcon
          // title="Delete Tile"
          style={{
            fontSize: "0.75rem",
            right: "5px",
            transform: "none",
            ...(popupClass ? {width:'0.75rem',height:'0.75rem' } : {}),
          }}
          className={`closeTile top-auto ${!inPopup ? "close-container" : ""} ${
            inPopup && selectedTile !== tileId ? "popupClose" : ""
          }
          ${inPopup && selectedTile === tileId ? "hidden" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            removeTile(tabId, tileId);
          }}
        /> */}
        <MoreVert
          style={{
            fontSize: '0.75rem',
            transform: 'none',
            backgroundColor: showDash ? tabAreaBackgroundColor : 'transparent',
            color: iconColor,
            ...(popupClass ? { width: '0.75rem', height: '0.75rem' } : {}),
          }}
          className={`closeTile top-auto ${!inPopup ? 'close-container' : ''} ${
            inPopup && selectedTile !== tileId ? 'popupClose' : ''
          }
          ${inPopup && showDash && tileListOpen ? 'popupClose' : inPopup && selectedTile === tileId ? 'hidden' : ''}`}
          onClick={handleClickAnchor}
        />
        <Menu
          anchorEl={anchorEl1}
          open={open1}
          onClose={handleCloseAnchor}
          PaperProps={{
            sx: {
              backgroundColor: tabAreaBackgroundColor,
              color: iconColor,
              mt: -2.2,
              boxShadow: `${iconColor === '#ffffff' ? '0px 2px 4px rgba(184, 159, 159, 0.5)' : '0px 2px 4px rgba(0, 0, 0, 0.2)'}`,
            },
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem
            onClick={() => {
              handleDuplicateAsCrossTab();
            }}
          >
            <ListItemIcon>
              <TableChartIcon style={{ width: 20, height: 20, color: iconColor }} />
            </ListItemIcon>
            <ListItemText
              primary="Duplicate Tile as a CrossTab"
              primaryTypographyProps={{ color: iconColor }}
            />
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              handleDuplicateTile();
              handleCloseAnchor();
            }}
          >
            <ListItemIcon>
              <Filter9PlusOutlinedIcon style={{ width: 20, height: 20, color: iconColor }} />
            </ListItemIcon>
            <ListItemText primary="Duplicate Tile" primaryTypographyProps={{ color: iconColor }} />
          </MenuItem>
          <Divider />
          <MenuItem
            disabled={totalTile === 1}
            selected={activeItem === 'move tile'}
            onClick={(e) => {
              e.stopPropagation();
              setSubMenuAnchorEl(e.currentTarget);
              setActiveItem('move tile');
            }}
          >
            <ListItemIcon>
              <LuMoveHorizontal style={{ width: 20, height: 20, color: iconColor }} />
            </ListItemIcon>
            <ListItemText primary="Move Tile" primaryTypographyProps={{ color: iconColor }} />
            <ArrowRightIcon style={{ width: 20, height: 20, color: iconColor }} />
          </MenuItem>
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              // selectTile(tileId, tileName, tabId, tabName);
              // renameTileBegin(tabId, tileId);
              selectAndRename();
              handleCloseAnchor();
            }}
          >
            <ListItemIcon>
              <DriveFileRenameOutlineOutlinedIcon
                style={{ width: 20, height: 20, color: iconColor }}
              />
            </ListItemIcon>
            <ListItemText primary="Rename Tile" primaryTypographyProps={{ color: iconColor }} />
          </MenuItem>
          {chartTitle &&
            chartTitle.trim() !== '' &&
            !chartTitle.toLowerCase().startsWith('untitled') && (
              <MenuItem
                onClick={(e) => {
                  e.stopPropagation();
                  handleRenameAsChartTitle();
                  handleCloseAnchor();
                }}
              >
                <ListItemIcon>
                  <DriveFileRenameOutlineOutlinedIcon
                    style={{ width: 20, height: 20, color: iconColor }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary="Rename as Chart Title"
                  slotProps={{
                    primary: {
                      sx: { color: iconColor },
                    },
                  }}
                />
              </MenuItem>
            )}
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              handleCloseAnchor();
              handleDeleteTile();
            }}
          >
            <ListItemIcon>
              <DeleteOutlineOutlinedIcon style={{ width: 20, height: 20, color: iconColor }} />
            </ListItemIcon>
            <ListItemText primary="Delete Tile" primaryTypographyProps={{ color: iconColor }} />
          </MenuItem>
        </Menu>

        {/* subMenu For Move Tile */}
        <Menu
          open={openSubMenu}
          anchorEl={subMenuAnchorEl}
          onClose={handleSubmenuClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            sx: {
              backgroundColor: tabAreaBackgroundColor,
              color: iconColor,
              boxShadow: `${iconColor === '#ffffff' ? '0px 2px 4px rgba(184, 159, 159, 0.5)' : '0px 2px 4px rgba(0, 0, 0, 0.2)'}`,
              mt: tileIndex !== 0 && tileIndex !== totalTile - 1 ? 1.5 : 0,
              width: 160,
            },
          }}
        >
          {getSubMenuOptions(tileIndex, totalTile)}
        </Menu>

        <DeleteConfirmationDialog
          open={showDeleteConfirmation}
          onClose={cancelDelete}
          onConfirm={confirmAndDelete}
          message={deleteMessage}
        />

        <NotificationDialog
          openAlert={notification.open}
          severity={notification.severity}
          testMessage={notification.message}
          onCloseAlert={handleCloseNotification}
        />
      </span>
    );
  }
};

const mapStateToProps = (state: RootState) => {
  return {
    tabState: state.tabState,
    tileState: state.tileState,
    tabTileProps: state.tabTileProps,
    chartProperties: state.chartProperties,
    chartControls: state.chartControls,
    chartGroup: state.chartFilterGroup,
    dashBoardFilterGroup: state.dashBoardFilterGroup,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    renameTile: (tabId: number, nextTileId: number, newName: string) =>
      dispatch(renameTile(tabId, nextTileId, newName)),
    actionsToAddTile: (
      tabId: number,
      nextTileId: number,
      table: any,
      fromTab: boolean,
      selectedDs: any,
      selectedTablesInDs: any,
      chartControls: ChartControlsProps,
    ) =>
      dispatch(
        actionsToAddTile({
          tabId,
          nextTileId,
          table,
          fromTab,
          selectedDs,
          selectedTablesInDs,
          chartControls,
        }),
      ),
    duplicateControl: (propKey: string, chartControl: ChartControlsProps) =>
      duplicateControl(propKey, chartControl),
    duplicateChartProperty: (propKey: string, chartProp: any) =>
      dispatch(duplicateChartProperty(propKey, chartProp)),
    addChartFilterTabTileName: (selectedDatasetID: string, tabTileName: string) =>
      dispatch(addChartFilterTabTileName(selectedDatasetID, tabTileName)),
    duplicateChartFilterGroups: (tabTileName: string, selectedGroups: any) =>
      dispatch(duplicateChartFilterGroups(tabTileName, selectedGroups)),
    updateSelectedTile: (tileName: string, tileId: number, nextTileId: number) =>
      dispatch(updateSelectedTile(tileName, tileId, nextTileId)),
    updateSelectedTileToTab: (tabId: number, tileName: string, tileId: number) =>
      dispatch(updateSelectedTileToTab(tabId, tileName, tileId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndividualTile);
